<div class="modal-box add-client-modal" cdkDrag>
    <form class="add-client-modal__form modal-form" [formGroup]="addClientForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-client-modal__header" cdkDragHandle>
            <div class="add-client-modal__headline modal-headline">
                <span class="add-client-modal__eyebrow modal-eyebrow">{{ (instance.isAltLayout ? 'LOCATION' : (isProspect ? 'PROSPECT' : 'CLIENT')) | translate }}</span>
                <h4 class="modal-title add-client-modal__title modal-heading">{{ (id === null ? (isProspect ? 'ADD_PROSPECT' : 'ADD_CLIENT') : (isProspect ? 'EDIT_PROSPECT' : 'EDIT_CLIENT')) | translate }}</h4>
            </div>
            <button type="button" class="add-client-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-client-modal__body">
            <div class="add-client-modal__sections modal-sections">
                <section class="add-client-modal__panel add-client-modal__panel--wide modal-panel">
                    <div class="add-client-modal__panel-header modal-panel-header">
                        <span class="add-client-modal__panel-eyebrow modal-panel-eyebrow">{{ 'CLIENT' | translate }}</span>
                    </div>

                    <div class="add-client-modal__grid add-client-modal__grid--core modal-grid">
                        <div *ngIf="!instance.isAltLayout" class="add-client-modal__field">
                            <label class="add-client-modal__label" for="firstName">{{ 'FIRST_NAME' | translate }}</label>
                            <input id="firstName" type="text" class="form-control add-client-modal__control" formControlName="firstName"
                                [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" [placeholder]="'ENTER_FIRST_NAME' | translate">
                            <div *ngIf="submitted && f.firstName.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.firstName.errors.required">{{ 'FIRST_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__field">
                            <label class="add-client-modal__label" for="lastName">{{ 'CLIENT_LAST_NAME' | translate }}</label>
                            <input id="lastName" type="text" class="form-control add-client-modal__control" formControlName="lastName"
                                [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" [placeholder]="'ENTER_CLIENT_LAST_NAME' | translate">
                            <div *ngIf="submitted && f.lastName.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.lastName.errors.required">{{ 'CLIENT_LAST_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__field">
                            <label class="add-client-modal__label" for="email">{{ 'EMAIL' | translate }}</label>
                            <input id="email" type="text" class="form-control add-client-modal__control" formControlName="email"
                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" [placeholder]="'ENTER_EMAIL_ADDRESS' | translate">
                            <div *ngIf="submitted && f.email.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.email.errors.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                                <div *ngIf="f.email.errors.email">{{ 'EMAIL_INVALID' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__field">
                            <label class="add-client-modal__label" for="phone">{{ 'PHONE' | translate }}</label>
                            <input id="phone" type="tel" class="form-control add-client-modal__control" formControlName="phone"
                                [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" [placeholder]="'ENTER_PHONE_NUMBER' | translate">
                            <div *ngIf="submitted && f.phone.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.phone.errors.required">{{ 'PHONE_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__field add-client-modal__field--span-2">
                            <label class="add-client-modal__label" for="brandAddress">{{ 'ADDRESS' | translate }}</label>
                            <textarea id="brandAddress" class="form-control add-client-modal__control add-client-modal__control--textarea" rows="3"
                                formControlName="brandAddress" [ngClass]="{ 'is-invalid': submitted && f.brandAddress.errors }"
                                [placeholder]="'ENTER_ADDRESS_INFO' | translate"></textarea>
                            <div *ngIf="submitted && f.brandAddress.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.brandAddress.errors.required">{{ 'ADDRESS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__billing-row add-client-modal__field--span-2">
                            <div class="add-client-modal__field add-client-modal__field--toggle">
                                <label class="add-client-modal__label">{{
                                    instance.isAltLayout
                                        ? (('ARCHIVE' | translate) + '/' + ('UNARCHIVE' | translate))
                                        : (('CLIENT' | translate) + '/' + ('PROSPECT' | translate))
                                }}</label>
                                <div class="add-client-modal__switch-wrap">
                                    <ui-switch [checked]="!!f.isProspect.value" size="small" (change)="f.isProspect.setValue(!!$event)"
                                        defaultBoColor="#dfdfdf" color="#cdcdcd"
                                        [checkedLabel]="instance.isAltLayout ? ('ARCHIVED' | translate) : ('PROSPECT' | translate)"
                                        [uncheckedLabel]="instance.isAltLayout ? ('LIVE' | translate) : ('CLIENT' | translate)"
                                        class="ms-1 bigger">
                                    </ui-switch>
                                </div>
                            </div>

                            <div *ngIf="!instance.isAltLayout" class="add-client-modal__field add-client-modal__field--invoice">
                                <label class="add-client-modal__label" for="emailForInvoice">{{ 'INVOICE_EMAIL' | translate }}</label>
                                <input id="emailForInvoice" type="text" class="form-control add-client-modal__control" formControlName="emailForInvoice"
                                    [placeholder]="'INVOICE_EMAIL_HINT' | translate">
                            </div>
                        </div>
                    </div>
                </section>

                <section class="add-client-modal__panel add-client-modal__panel--wide modal-panel">

                    <div class="add-client-modal__grid modal-grid">
                        <div class="add-client-modal__field">
                            <label class="add-client-modal__label" for="brandId">{{ 'COMPANY' | translate }}</label>
                            <ng-select id="brandId" class="add-client-modal__select" [placeholder]="'SELECT_A_COMPANY' | translate"
                                [ngClass]="{ 'is-invalid': submitted && f.brandId.errors }" formControlName="brandId">
                                <ng-option *ngFor="let rep of allCompanies" [value]="rep.id">{{rep.name}}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.brandId.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.brandId.errors.required">{{ 'COMPANY_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__field">
                            <label class="add-client-modal__label" for="dmsId">{{ 'DMS' | translate }}</label>
                            <ng-select id="dmsId" class="add-client-modal__select" [placeholder]="'SELECT_A_DMS' | translate"
                                [ngClass]="{ 'is-invalid': submitted && f.dmsId.errors }" formControlName="dmsId">
                                <ng-option *ngFor="let rep of allDms" [value]="rep.id">{{rep.firstName}} {{rep.lastName}}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.dmsId.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.dmsId.errors.required">{{ 'DMS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div *ngIf="!instance.isAltLayout" class="add-client-modal__field">
                            <label class="add-client-modal__label" for="salesRepId">{{ 'SALES_REP' | translate }}</label>
                            <ng-select id="salesRepId" class="add-client-modal__select" [placeholder]="'SELECT_A_SALES_REP' | translate"
                                [ngClass]="{ 'is-invalid': submitted && f.salesRepId.errors }" formControlName="salesRepId">
                                <ng-option *ngFor="let rep of allSalesReps" [value]="rep.id">{{rep.firstName}} {{rep.lastName}}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.salesRepId.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.salesRepId.errors.required">{{ 'SALES_REP_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-client-modal__field">
                            <label class="add-client-modal__label" for="clientOwnerId">{{ 'OWNER' | translate }}</label>
                            <ng-select id="clientOwnerId" class="add-client-modal__select" [placeholder]="'SELECT_A_CLIENT_OWNER' | translate"
                                [ngClass]="{ 'is-invalid': submitted && f.clientOwnerId.errors }"
                                [readonly]="client != undefined && !client.clientOwnerEditable" formControlName="clientOwnerId">
                                <ng-option *ngFor="let user of allClientOwners" [value]="user.id">
                                    {{ (instance.isLastNameFirst ? (user.lastName + ' ' + user.firstName) : (user.firstName + ' ' + user.lastName)).trim() }}
                                </ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.clientOwnerId.errors" class="add-client-modal__feedback">
                                <div *ngIf="f.clientOwnerId.errors.required">{{ 'OWNER_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="add-client-modal__panel add-client-modal__panel--wide modal-panel">
                    <div class="add-client-modal__panel-header modal-panel-header">
                        <span class="add-client-modal__panel-eyebrow modal-panel-eyebrow">{{ 'TEAM' | translate }}</span>
                        <h5 class="add-client-modal__panel-title modal-panel-title">{{ 'ASSIGNED_EMPLOYEES' | translate }}</h5>
                    </div>

                    <div class="add-client-modal__employees">
                        <div class="add-client-modal__employee-empty" *ngIf="f.employees.value?.length === 0">{{ 'NO_EMPLOYEE_FOUND' | translate }}</div>
                        <div class="add-client-modal__employee-list" *ngIf="f.employees.value?.length > 0">
                            <span class="add-client-modal__employee-pill" *ngFor="let e of f.employees.value">{{e.fullName}}</span>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer add-client-modal__footer" cdkDragHandle>
            <div class="add-client-modal__actions modal-actions">
                <button type="button" class="red-outline-button add-client-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button type="submit" class="blue-button add-client-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
